/**
 * @Author: memo
 * @Date:   2020-02-16T15:10:10-06:00
 * @Email:  g.correa@kimeras-studio.com
 * @Project: Farmazon API
 * @Last modified by:   memo
 * @Last modified time: 2020-02-16T15:11:29-06:00
 * @License: MIT
 */
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const initialState = {};

const middleware = [thunk];

const store = createStore(
	rootReducer,
	initialState,
	compose(
		applyMiddleware(...middleware),
		(window.__REDUX_DEVTOOLS_EXTENSION__ &&
			window.__REDUX_DEVTOOLS_EXTENSION__()) ||
		compose
	)
);

export default store;
